export default __webpack_public_path__ + "static/media/calculator.a4102831.png";